/* eslint-disable linebreak-style */
/* eslint-disable import/extensions */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable react/react-in-jsx-scope */
/* eslint-disable-next-line no-unused-vars */
import { Route, Routes } from 'react-router-dom';

import LandingPage from 'pages/LandingPage';
import ProjectPage from 'pages/ProjectPage';
import NotFoundPage from 'pages/NotFoundPage';
import { DiscussProjectPage } from 'pages/DiscussProjectPage';
import CompanyCharterPage from 'pages/CompanyCharterPage';
import CharterPortfolioPage from './pages/CharterPortfolioPage'; 
import LoginPage from './pages/LoginPage';
import './assets/css/styles.css';
import BlogPage from "./pages/BlogPage";
import BlogDetailPage from "./pages/BlogDetailPage";

function App() {
  return (
    <>
      <Routes>
        <Route exact path="/" element={<LandingPage />} />
        <Route path="/about-guvrn" element={<ProjectPage />} />
        <Route path="/charters" element={<CharterPortfolioPage />} /> 
        <Route path="/company-charter" element={<CompanyCharterPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route exact path="/contact-guvrn" element={<DiscussProjectPage />} />
        <Route path="**" element={<NotFoundPage />} />
         {/* Hidden for now */}
         <Route path="/guvrnspeak" element={<BlogPage />} />
         <Route path="/guvrnspeak/:slug" element={<BlogDetailPage />} />
      </Routes>
    </>
  );
}

export default App;
